(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 1240:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8210);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useGetStartedAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useGetStartedAction = ()=>{
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    const handleClick = ()=>{
        window.open("https://www.artplacer.com/signup?email=".concat(email));
    };
    return {
        email,
        setEmail,
        handleClick
    };
};


/***/ }),

/***/ 4064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4051);
/* harmony import */ var _Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8966);
/* harmony import */ var _Banner_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8927);
/* harmony import */ var _Banner_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Banner_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);







const Banner = (param)=>{
    let { children , image , height =500 , title , description , cta ="CTA" , onClick , contact =false  } = param;
    const defaultImage = "/images/banner-gallery.png";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Banner_module_css__WEBPACK_IMPORTED_MODULE_4___default().banner), "d-flex flex-column justify-content-center", "mb-4"),
        style: {
            backgroundImage: "url(".concat(image || defaultImage, ")"),
            height: "".concat(height, "px")
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container position-relative z-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        xs: 12,
                        sm: 12,
                        md: 8,
                        lg: 8,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("banner-text", contact ? (_Banner_module_css__WEBPACK_IMPORTED_MODULE_4___default().bannerTopPadding) : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("fw-300 text-white fs-56px fs-mobile-40px lh-100", contact ? "mb-0" : "mb-4"),
                                    children: [
                                        title,
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-white font-primary fs-18px mb-4",
                                    children: [
                                        description,
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_2__/* .ButtonCta */ .N, {
                                    onClick: onClick,
                                    title: cta
                                })
                            ]
                        })
                    })
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 3280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3992);
/* harmony import */ var _Layout_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6627);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8351);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__);







const CircleImages = (param)=>{
    let { title , subtitle , image , href , to  } = param;
    const initials = title.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "").toUpperCase().substring(0, 3);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: to,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["circle-image-container"]), "margin m0a"),
        children: [
            image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_Image__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .E, {
                src: (0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__/* .imageResizer */ .J)(image, 200, 200),
                width: "150px",
                height: "150px",
                labelHeight: "150px",
                labelWidth: "150px",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default().circles), "mb-4", "mx-auto"),
                alt: title
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-logo"]), "mb-4", "mx-auto"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-inicials"]),
                    children: initials
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "text-black text-center mb-2 font-secondary fw-700 fs-16px",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-center color-gray-super-light font-primary fs-13px font-primary",
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CircleImages);


/***/ }),

/***/ 9442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Exhibitions_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(874);
/* harmony import */ var _Exhibitions_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Exhibitions_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);





const ExhibitionCard = (props)=>{
    const { id , description , image , date , title , href , to , author  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: href,
        as: to,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Exhibitions_module_css__WEBPACK_IMPORTED_MODULE_4___default().exhibitions),
            style: {
                backgroundImage: "url(".concat(image, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Exhibitions_module_css__WEBPACK_IMPORTED_MODULE_4___default().exhibitionInfo),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "color-white fs-16px",
                        children: title.toUpperCase()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Exhibitions_module_css__WEBPACK_IMPORTED_MODULE_4___default().bottom),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "color-white mb-0 font-primary fs-14px ",
                                children: author
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "fs-13px",
                                children: date
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExhibitionCard);


/***/ }),

/***/ 158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4425);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_module_css__WEBPACK_IMPORTED_MODULE_3__);




const Button = (param)=>{
    let { name , children , isAppleButton , isAndroidButton , type ="button" , onClick =()=>{} , size ="lg" , width , disabled =false , variant ="dark" , sx  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default()["button-container"]), "cursor-pointer", isAppleButton ? (_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().apple) : isAndroidButton ? (_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().android) : "", sx),
        style: {
            width: width ? width : "auto"
        },
        onClick: ()=>onClick(),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            disabled: disabled,
            type: type,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("btn-".concat(size, " btn-sm btn-block btn-").concat(variant, " fw-700 fs-12px ").concat((_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().button))),
            children: name || children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 8966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ButtonCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1772);
/* harmony import */ var _ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ButtonCta = (param)=>/*#__PURE__*/ {
    let { className , onClick , title , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "btn btn-outline-secondary fs-12px tt-u", (_ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button)),
        children: title || children
    });
};


/***/ }),

/***/ 1286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Container = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HelmetTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const HelmetTitle = (param)=>/*#__PURE__*/ {
    let { title , hide =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: "".concat(title).concat(hide ? "" : " | Discover ArtPlacer")
        })
    });
};


/***/ }),

/***/ 6627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./features/components/Layout/LoadingLabel/LoadingLabel.module.scss
var LoadingLabel_module = __webpack_require__(7129);
var LoadingLabel_module_default = /*#__PURE__*/__webpack_require__.n(LoadingLabel_module);
;// CONCATENATED MODULE: ./features/components/Layout/LoadingLabel/index.js




const LoadingLabel = (param)=>/*#__PURE__*/ {
    let { height , width , maxWidth , className  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((LoadingLabel_module_default())["loading-label"], className),
        style: {
            height,
            width,
            maxWidth
        }
    });
};
LoadingLabel.defaultProps = {
    height: 16,
    width: "100%",
    className: ""
};

;// CONCATENATED MODULE: ./features/components/Layout/Image/index.js



const Image = (param)=>{
    let { src , labelHeight ="250px" , labelWidth ="100%" , ...rest } = param;
    const [loaded, setLoaded] = (0,react.useState)(false);
    const img = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (img.current.complete) {
            setLoaded(true);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingLabel, {
                className: rest.className,
                height: labelHeight,
                width: labelWidth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src,
                ref: img,
                alt: rest.alt || "",
                style: {
                    display: loaded ? "block" : "none"
                },
                ...rest,
                onLoad: ()=>setLoaded(true)
            })
        ]
    });
};
766;


/***/ }),

/***/ 7182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SeoTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const SeoTags = (param)=>{
    let { description , title , image ="https://artplacer-nextjs.herokuapp.com/artplacer-logo.png" , url , canonical  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            })
        ]
    });
};


/***/ }),

/***/ 2578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3992);
/* harmony import */ var _LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1798);
/* harmony import */ var _LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);






const LikeCards = (param)=>{
    let { title , subtitle , subSubTitle , image , to , href , type ="small"  } = param;
    let width, height;
    switch(type){
        case "big":
            width = "AUTO";
            height = 900;
            break;
        case "aspect-ratio":
            width = "AUTO";
            height = 200;
            break;
        default:
        case "small":
            width = 600;
            height = "AUTO";
            break;
    }
    const Card = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mb-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4___default()["like-cards"]), "like-cards", (_LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4___default())[type], "d-flex", "justify-content-center", "align-items-center"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_5__/* .imageResizer */ .J)(image, width, height),
                        alt: title
                    })
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    className: "text-black mb-0 font-secondary fw-700 fs-16px elipsis-2-lines",
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-0 font-primary text-black fs-14px font-primary",
                    children: subtitle
                }),
                subSubTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-0 color-gray-super-light fs-13px font-primary fs-13px",
                    children: subSubTitle
                })
            ]
        });
    if (to && href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            as: to,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {})
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (LikeCards);


/***/ }),

/***/ 3827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ Masonry; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3992);
/* harmony import */ var _Layout_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6627);
/* harmony import */ var _Masonry_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4917);
/* harmony import */ var _Masonry_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Masonry_module_scss__WEBPACK_IMPORTED_MODULE_4__);






const Masonry = (param)=>{
    let { items  } = param;
    const Item = (param)=>{
        let { title , subtitle , subSubTitle , sold , price , lastLine , image , to , href , textAlign ="center"  } = param;
        const Card = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-2 text-".concat(textAlign, " ").concat((_Masonry_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_Image__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                        src: (0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_5__/* .imageResizer */ .J)(image, 800, "AUTO"),
                        alt: title,
                        className: "mb-2 m0a"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "text-black mb-0 font-secondary fw-700 fs-16px",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-0 font-primary text-black fs-14px font-primary",
                        children: subtitle
                    }),
                    subSubTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-0 color-gray-super-light fs-13px font-primary fs-09em",
                        children: subSubTitle
                    }),
                    sold && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "mb-2 text-black fs-14px font-secondary fw-700",
                        children: "Sold"
                    }),
                    !sold && price && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "mb-2 text-black fs-14px font-secondary fw-700",
                        children: price
                    }),
                    lastLine && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-2 color-gray-super-light fs-13px font-primary fs-09em",
                        children: lastLine
                    })
                ]
            });
        if (to && href) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: href,
                as: to,
                className: (_Masonry_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {})
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {});
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Masonry_module_scss__WEBPACK_IMPORTED_MODULE_4___default().row),
        children: items.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                ...item
            }, item.to))
    });
};


/***/ }),

/***/ 7062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ HomeCarousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1555);
/* harmony import */ var react_multi_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6529);
/* harmony import */ var _services_utils_linksBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3372);
/* harmony import */ var _services_utils_useNavigateTo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5334);
/* harmony import */ var _components_CirclesImages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3280);







const responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1200
        },
        items: 6,
        slidesToSlide: 5
    },
    desktopSmall: {
        breakpoint: {
            max: 1200,
            min: 1024
        },
        items: 4,
        slidesToSlide: 4
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 2,
        slidesToSlide: 2
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        slidesToSlide: 1
    }
};
const HomeCarousel = (param)=>{
    let { featuredGalleries  } = param;
    const navigateTo = (0,_services_utils_useNavigateTo__WEBPACK_IMPORTED_MODULE_4__/* .useNavigateTo */ .j)();
    const onNavigate = async ()=>{
        await navigateTo("/galleries");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                lg: 6,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-black mb-1 fs-24px",
                                        children: "Featured Galleries"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "color-gray-super-light font-primary fs-13px",
                                        children: "A selection of our favorite galleries and artists."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        className: "text-left text-sm-right",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            onClick: ()=>onNavigate(),
                            className: "font-primary td-u fs-14px cursor-pointer color-black",
                            children: "View all"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "position-relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_multi_carousel__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    additionalTransfrom: 0,
                    arrows: true,
                    autoPlaySpeed: 3000,
                    centerMode: false,
                    className: "w-100",
                    containerClass: "container-with-dots home-galleries-carousel",
                    dotListClass: "",
                    draggable: true,
                    focusOnSelect: false,
                    infinite: false,
                    itemClass: "",
                    keyBoardControl: true,
                    minimumTouchDrag: 80,
                    renderButtonGroupOutside: false,
                    renderDotsOutside: false,
                    responsive: responsive,
                    children: featuredGalleries.map((featuredGallery)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CirclesImages__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                title: featuredGallery.gallery.name,
                                subtitle: featuredGallery.gallery.address,
                                image: featuredGallery.gallery.thumbnail,
                                href: "/galleries/[id]",
                                to: _services_utils_linksBuilder__WEBPACK_IMPORTED_MODULE_3__/* .linksBuilder.galleries */ .m.galleries(featuredGallery.gallery.domain)
                            })
                        }, "featured-galleries-".concat(featuredGallery.gallery.id)))
                })
            })
        ]
    });
};


/***/ }),

/***/ 8210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./services/utils/images.js
var utils_images = __webpack_require__(3370);
// EXTERNAL MODULE: ./services/utils/useNavigateTo.js
var utils_useNavigateTo = __webpack_require__(5334);
// EXTERNAL MODULE: ./features/components/Banner/index.js
var Banner = __webpack_require__(4064);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var esm_Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var esm_Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./features/actions/useGetStartedAction.js
var useGetStartedAction = __webpack_require__(6882);
// EXTERNAL MODULE: ./features/components/Layout/Button/index.js
var Button = __webpack_require__(158);
// EXTERNAL MODULE: ./features/components/Layout/ButtonCta/index.js
var ButtonCta = __webpack_require__(8966);
// EXTERNAL MODULE: ./features/components/BannerFooter/BannerFooter.module.scss
var BannerFooter_module = __webpack_require__(3576);
var BannerFooter_module_default = /*#__PURE__*/__webpack_require__.n(BannerFooter_module);
;// CONCATENATED MODULE: ./features/actions/useDownloadApp.js
const useDownloadApp = ()=>{
    window.open("https://apps.apple.com/ar/app/artplacer/id1083122176");
};
const useGetItOn = ()=>{
    window.open("https://play.google.com/store/apps/details?id=com.artplacer.artplacer");
};

;// CONCATENATED MODULE: ./features/actions/useDeviceDetection.js

const useDeviceDetection = ()=>{
    const [deviceInfo, setDeviceInfo] = (0,react.useState)({
        isMobile: false,
        isIOS: false,
        isAndroid: false
    });
    (0,react.useEffect)(()=>{
        if (typeof navigator !== "undefined") {
            const ua = navigator.userAgent;
            const isAndroid = /android/i.test(ua);
            const isIOS = /iPad|iPhone|iPod/.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
            const isMobile = isAndroid || isIOS || /Mobi|Android/i.test(ua);
            setDeviceInfo({
                isMobile,
                isIOS,
                isAndroid
            });
        }
    }, []);
    return deviceInfo;
};

;// CONCATENATED MODULE: ./features/components/BannerFooter/index.js











const BannerFooter = (param)=>{
    let { children , cta , isMobileBanner , showEmail , textAlign ="left" , titleClasses , image  } = param;
    const { email , setEmail , handleClick  } = (0,useGetStartedAction/* useGetStartedAction */.L)();
    const { isMobile , isIOS , isAndroid  } = useDeviceDetection();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((BannerFooter_module_default()).imgFooter, "d-flex", "align-items-center"),
        style: {
            backgroundImage: "url(".concat(image, ")")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container-fluid z-1 text-".concat(textAlign),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        className: "px-md-0",
                        xs: 12,
                        sm: 12,
                        md: textAlign === "center" ? 12 : 8,
                        lg: textAlign === "center" ? 12 : 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: classnames_default()((BannerFooter_module_default()).white, titleClasses),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-0 ml-md-5",
                                children: children
                            })
                        })
                    })
                }),
                showEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row/* default */.Z, {
                    className: textAlign === "center" ? "justify-content-center" : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        md: 3,
                        className: classnames_default()("px-0 px-md-0 ml-0 ml-md-5", (BannerFooter_module_default()).mobilecta),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCta/* ButtonCta */.N, {
                            className: classnames_default()((BannerFooter_module_default())["custom-cta"]),
                            onClick: handleClick,
                            title: cta
                        })
                    })
                }),
                !showEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row/* default */.Z, {
                    className: "text-".concat(textAlign),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col/* default */.Z, {
                        className: "m0a",
                        children: [
                            (!isMobile || isIOS) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                isAppleButton: isMobileBanner,
                                onClick: useDownloadApp,
                                children: cta
                            }),
                            (!isMobile || isAndroid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                isAndroidButton: isMobileBanner,
                                onClick: useGetItOn,
                                children: cta
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_BannerFooter = (BannerFooter);

// EXTERNAL MODULE: ./features/components/BannerAr/BannerAr.module.scss
var BannerAr_module = __webpack_require__(6574);
var BannerAr_module_default = /*#__PURE__*/__webpack_require__.n(BannerAr_module);
;// CONCATENATED MODULE: ./features/components/BannerAr/index.js









const BannerAr = (param)=>{
    let { cta , isMobileBanner  } = param;
    const { isMobile , isIOS , isAndroid  } = useDeviceDetection();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((BannerAr_module_default()).imgFooter, "d-flex", "align-items-center"),
        style: {
            backgroundColor: "#EFEBE8"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid z-1 h-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Row/* default */.Z, {
                className: "h-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        className: "p-3 py-md-5 pb-md-0 pl-md-6 pr-md-0 h-100 d-flex align-items-center justify-content-center",
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Row/* default */.Z, {
                            className: "text-center text-sm-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col/* default */.Z, {
                                    xs: 12,
                                    className: "m0a",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "m-0 p-0 text-black fs-24px fs-mobile-20px",
                                            children: "View these beautiful pieces in your home using"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "m-0 p-0 text-black fs-24px fs-mobile-20px",
                                            children: "Augmented Reality technology."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col/* default */.Z, {
                                    xs: 12,
                                    className: "m0a mt-4",
                                    children: [
                                        (!isMobile || isIOS) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            isAppleButton: isMobileBanner,
                                            onClick: useDownloadApp,
                                            sx: "ml-0 mr-2 bg-transparent",
                                            variant: "rounded",
                                            children: cta
                                        }),
                                        (!isMobile || isAndroid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            isAndroidButton: isMobileBanner,
                                            onClick: useGetItOn,
                                            sx: "mx-0 bg-transparent",
                                            variant: "rounded",
                                            children: cta
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        className: "pt-3 pt-md-5 pr-md-6 h-100 d-none d-sm-flex align-items-end justify-content-center",
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "images/banner_ar_app.svg",
                            alt: "ar image",
                            style: {
                                maxHeight: "100%"
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_BannerAr = (BannerAr);

// EXTERNAL MODULE: ./features/components/Layout/Container/index.js
var Container = __webpack_require__(1286);
// EXTERNAL MODULE: ./features/components/Layout/HelmetTitle/index.js
var HelmetTitle = __webpack_require__(6470);
// EXTERNAL MODULE: ./features/components/Layout/SeoTags/index.js
var SeoTags = __webpack_require__(7182);
// EXTERNAL MODULE: ./services/utils/linksBuilder.js
var linksBuilder = __webpack_require__(3372);
// EXTERNAL MODULE: ./features/components/LikeCards/index.js
var LikeCards = __webpack_require__(2578);
// EXTERNAL MODULE: ./features/components/Masonry/index.js
var components_Masonry = __webpack_require__(3827);
// EXTERNAL MODULE: ./services/utils/getArtworkSize.js
var getArtworkSize = __webpack_require__(731);
// EXTERNAL MODULE: ./services/utils/getArtworkTitle.js
var getArtworkTitle = __webpack_require__(194);
// EXTERNAL MODULE: ./services/utils/getArtworkSubtitle.js
var getArtworkSubtitle = __webpack_require__(9296);
;// CONCATENATED MODULE: ./features/pages/HomePage/FeaturedArtworks.js










const FeaturedArtworks = (param)=>{
    let { featuredArtworks , featuredGalleries  } = param;
    const navigateTo = (0,utils_useNavigateTo/* useNavigateTo */.j)();
    const galleryDomainsById = (featuredGalleries || []).reduce((acc, item)=>{
        const gallery = item === null || item === void 0 ? void 0 : item.gallery;
        if ((gallery === null || gallery === void 0 ? void 0 : gallery.id) && (gallery === null || gallery === void 0 ? void 0 : gallery.domain)) {
            acc[gallery.id] = gallery.domain;
        }
        return acc;
    }, {});
    const onNavigate = async ()=>{
        await navigateTo("/artworks");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Row/* default */.Z, {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-black mb-1 fs-24px",
                            children: "Featured Artworks"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        className: "text-left text-sm-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: ()=>onNavigate(),
                            className: "font-primary td-u fs-14px cursor-pointer color-black",
                            children: "View all"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row/* default */.Z, {
                children: featuredArtworks.map((featuredArtwork)=>{
                    var _featuredArtwork_artwork_gallery, _featuredArtwork_artwork_gallery1, _featuredArtwork_artwork_gallery2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeCards/* default */.Z, {
                            title: (0,getArtworkTitle/* getArtworkTitle */.H)(featuredArtwork.artwork.title),
                            subtitle: (0,getArtworkSubtitle/* getArtworkSubtitle */.z)(featuredArtwork.artwork.artistname, (_featuredArtwork_artwork_gallery = featuredArtwork.artwork.gallery) === null || _featuredArtwork_artwork_gallery === void 0 ? void 0 : _featuredArtwork_artwork_gallery.name),
                            subSubTitle: (0,getArtworkSize/* getArtworkSize */.Y)(featuredArtwork.artwork.width, featuredArtwork.artwork.height),
                            to: linksBuilder/* linksBuilder.artworks */.m.artworks(((_featuredArtwork_artwork_gallery1 = featuredArtwork.artwork.gallery) === null || _featuredArtwork_artwork_gallery1 === void 0 ? void 0 : _featuredArtwork_artwork_gallery1.domain) || galleryDomainsById[featuredArtwork.artwork.galleryid], featuredArtwork.artwork.id, featuredArtwork.artwork.title),
                            href: ((_featuredArtwork_artwork_gallery2 = featuredArtwork.artwork.gallery) === null || _featuredArtwork_artwork_gallery2 === void 0 ? void 0 : _featuredArtwork_artwork_gallery2.domain) || galleryDomainsById[featuredArtwork.artwork.galleryid] ? "/galleries/[id]/artworks/[artwork]" : "/artworks/[artwork]",
                            image: featuredArtwork.artwork.image
                        })
                    }, featuredArtwork.artwork.id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/pages/HomePage/HomeCarousel.js
var HomeCarousel = __webpack_require__(7062);
;// CONCATENATED MODULE: ./features/pages/HomePage/MonthlyPicks.js









const MonthlyPicks = (param)=>{
    let { artworks  } = param;
    const navigateTo = (0,utils_useNavigateTo/* useNavigateTo */.j)();
    const onNavigate = async ()=>{
        await navigateTo("/artworks");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Row/* default */.Z, {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-black mb-1 fs-24px",
                            children: "Inspiring Monthly Picks"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        className: "text-left text-sm-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: ()=>onNavigate(),
                            className: "font-primary td-u fs-14px cursor-pointer color-black",
                            children: "View all"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row/* default */.Z, {
                children: artworks.map((artwork)=>{
                    var _artwork_gallery, _artwork_gallery1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeCards/* default */.Z, {
                            title: (0,getArtworkTitle/* getArtworkTitle */.H)(artwork.title),
                            subtitle: (0,getArtworkSubtitle/* getArtworkSubtitle */.z)(artwork.artistname, (_artwork_gallery = artwork.gallery) === null || _artwork_gallery === void 0 ? void 0 : _artwork_gallery.name),
                            subSubTitle: (0,getArtworkSize/* getArtworkSize */.Y)(artwork.width, artwork.height),
                            to: linksBuilder/* linksBuilder.artworks */.m.artworks((_artwork_gallery1 = artwork.gallery) === null || _artwork_gallery1 === void 0 ? void 0 : _artwork_gallery1.domain, artwork.id, artwork.title),
                            href: "/galleries/[id]/artworks/[artwork]",
                            image: artwork.image,
                            type: "big"
                        })
                    }, artwork.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/pages/HomePage/FeaturedRooms.js





const FeaturedRooms = (param)=>{
    let { featuredSpaces  } = param;
    const navigateTo = useNavigateTo();
    const onNavigate = async ()=>{
        await navigateTo("/spaces");
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ _jsxs(Col, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "text-black mb-1 fs-24px",
                                children: "Featured Spaces"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "color-gray-super-light font-primary fs-13px",
                                children: "Create the perfect art wall. See how the art pieces you love come together in space."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        className: "text-left text-sm-right",
                        children: /*#__PURE__*/ _jsx("span", {
                            onClick: ()=>onNavigate(),
                            className: "font-primary td-u fs-14px cursor-pointer color-black",
                            children: "View all"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Masonry, {
                id: "featured-rooms",
                items: featuredSpaces.map((featuredSpace)=>({
                        title: featuredSpace.gallery.name,
                        subtitle: featuredSpace.space.title,
                        image: featuredSpace.space.image,
                        to: "/spaces/".concat(featuredSpace.galleryspaceid),
                        href: "/spaces/[id]"
                    }))
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/components/ExhibitionCard/index.js
var ExhibitionCard = __webpack_require__(9442);
// EXTERNAL MODULE: ./services/utils/imageResizer.js
var imageResizer = __webpack_require__(3992);
;// CONCATENATED MODULE: ./features/pages/HomePage/FeaturedExhibitions.js






const FeaturedExhibitions = (param)=>{
    let { featuredExhibitions  } = param;
    const navigateTo = (0,utils_useNavigateTo/* useNavigateTo */.j)();
    const onNavigate = async ()=>{
        await navigateTo("/exhibitions");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Row/* default */.Z, {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-black mb-1 fs-24px",
                            children: "Featured Virtual Exhibitions"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        className: "text-left text-sm-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: ()=>onNavigate(),
                            className: "font-primary td-u fs-14px cursor-pointer color-black",
                            children: "View all"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row/* default */.Z, {
                children: featuredExhibitions.map((param)=>/*#__PURE__*/ {
                    let { exhibition  } = param;
                    return (0,jsx_runtime.jsx)(esm_Col/* default */.Z, {
                        xs: 12,
                        md: 3,
                        lg: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExhibitionCard/* default */.Z, {
                            id: exhibition.id,
                            image: (0,imageResizer/* imageResizer */.J)(exhibition.image, 600, "AUTO"),
                            title: exhibition.title,
                            date: exhibition.date,
                            author: exhibition.author,
                            to: "/exhibitions/".concat(exhibition.id),
                            href: "/exhibitions/[id]"
                        })
                    }, exhibition.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/pages/HomePage/index.js
















const HomePage = (param)=>{
    let { homeInfo  } = param;
    const navigateTo = (0,utils_useNavigateTo/* useNavigateTo */.j)();
    const onClickBanner = ()=>{
        navigateTo("/artworks");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* SeoTags */.o, {
                title: "Discover ArtPlacer | Explore art and galleries, visualize art in space",
                description: "Discover ArtPlacer is where the ArtPlacer community gathers together. Explore and find the most exquisite artworks and the best galleries in the world.",
                image: "https://artplacer-nextjs.herokuapp.com/artplacer-logo.png",
                url: "https://discover.artplacer.com/",
                canonical: "https://discover.artplacer.com/"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelmetTitle/* HelmetTitle */.i, {
                hide: true,
                title: "Discover ArtPlacer | Explore art and galleries, visualize art in space"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
                height: 450,
                image: utils_images/* images.home.header */.W.home.header,
                title: "Explore the world of art",
                description: "Dive into ArtPlacer’s community of artists and galleries. Discover portfolios from around the world.",
                cta: "START EXPLORING",
                onClick: onClickBanner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5 pt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedExhibitions, {
                            featuredExhibitions: homeInfo.featured_exhibitions
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCarousel/* HomeCarousel */.V, {
                            featuredGalleries: homeInfo.featured_galleries
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedArtworks, {
                            featuredArtworks: homeInfo.featured_artworks,
                            featuredGalleries: homeInfo.featured_galleries
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthlyPicks, {
                            artworks: homeInfo.monthly_picks
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BannerAr, {
                    cta: "DOWNLOAD THE APP",
                    isMobileBanner: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_BannerFooter, {
                    image: utils_images/* images.home.footer */.W.home.footer,
                    cta: "Free 14-day Trial",
                    showEmail: true,
                    textAlign: "center",
                    titleClasses: "fs-24px fs-mobile-20px font-secondary fw-400",
                    children: [
                        "Showcase your work. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Create your own Gallery Profile."
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var pages_HomePage = (HomePage);

;// CONCATENATED MODULE: ./pages/index.js



const Home = (param)=>{
    let { homeInfo  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_HomePage, {
        homeInfo: homeInfo
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getArtworkSize; }
/* harmony export */ });
const getArtworkSize = (width, height)=>{
    const w = parseFloat(width) ? parseFloat(width) + '" W' : "";
    const h = parseFloat(height) ? parseFloat(height) + '" H' : "";
    return [
        h,
        w
    ].filter(Boolean).join(" x ");
};


/***/ }),

/***/ 9296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getArtworkSubtitle; }
/* harmony export */ });
/* harmony import */ var _isKnownArtist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5157);

const getArtworkSubtitle = (artistname, galleryName)=>{
    if (!(0,_isKnownArtist__WEBPACK_IMPORTED_MODULE_0__/* .isKnownArtist */ .b)(artistname)) return galleryName !== null && galleryName !== void 0 ? galleryName : null;
    return artistname;
};


/***/ }),

/***/ 194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getArtworkTitle; }
/* harmony export */ });
const FILENAME_PATTERN = /^_?(DSC|IMG|DSCN|_MG|MVI|VID|MOV|P\d{3,})[\w-]*$|^.+\.(jpe?g|png|gif|tiff?|raw|cr2|nef|bmp|webp|heic)$/i;
const getArtworkTitle = (title)=>{
    if (typeof title !== "string") return "Untitled";
    const trimmed = title.trim();
    if (!trimmed || FILENAME_PATTERN.test(trimmed)) return "Untitled";
    return trimmed;
};


/***/ }),

/***/ 3992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ imageResizer; }
/* harmony export */ });
const imageResizer = (image, width, height)=>{
    if (!image) {
        return null;
    }
    if (!image.includes("cloudfront.net")) {
        return image;
    }
    const splittedImage = image.split("/");
    splittedImage.splice(splittedImage.length - 1, 0, "".concat(width, "x").concat(height));
    return splittedImage.join("/");
};


/***/ }),

/***/ 3370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ images; }
/* harmony export */ });
const images = {
    home: {
        header: "/images/Home-Banner.jpg",
        footer: "/images/Home-Banner-Footer.jpg"
    },
    contact: {
        header: "/images/ContactUs-Banner-New.jpg",
        side: "/images/Contact-Side-New.jpg"
    }
};


/***/ }),

/***/ 5157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ isKnownArtist; }
/* harmony export */ });
const isKnownArtist = (artistname)=>Boolean(artistname) && artistname !== "Unknown Artist";


/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ linksBuilder; }
/* harmony export */ });
/* harmony import */ var _slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3384);

const linksBuilder = {
    artworks: (domain, id, str)=>domain ? "/galleries/".concat(domain, "/artworks/").concat(id, "-").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .l)(str)) : "/artworks/".concat(id, "-").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .l)(str)),
    galleries: (str)=>"/galleries/".concat(str),
    collections: (id, collection)=>"/galleries/".concat(id, "/collections/").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugifyCollection */ .b)(collection))
};


/***/ }),

/***/ 3384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ slugifyCollection; },
/* harmony export */   "l": function() { return /* binding */ slugify; }
/* harmony export */ });
const slugify = (str)=>str.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
const slugifyCollection = (str)=>encodeURIComponent(str.toLowerCase());


/***/ }),

/***/ 8927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__HlBcZ","container":"Banner_container__aD_nI","banner-text":"Banner_banner-text__tRy2N","white":"Banner_white__QZW0K","bannerTopPadding":"Banner_bannerTopPadding__mcq09"};

/***/ }),

/***/ 8351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle-image-container":"CircleImages_circle-image-container__3OhLu","circles":"CircleImages_circles__kYojl","gallery-logo":"CircleImages_gallery-logo__7PsMY","gallery-inicials":"CircleImages_gallery-inicials__MpC3t"};

/***/ }),

/***/ 874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"exhibitions":"Exhibitions_exhibitions__luluZ","exhibitionInfo":"Exhibitions_exhibitionInfo__Z5P53","bottom":"Exhibitions_bottom__R7pep","lh17px":"Exhibitions_lh17px__qxT5o"};

/***/ }),

/***/ 4425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button-container":"Button_button-container__qEZ80","button":"Button_button__C97FB","android":"Button_android__22fHr","apple":"Button_apple__tbbth"};

/***/ }),

/***/ 1798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"like-cards":"LikeCards_like-cards__HIXtb","big":"LikeCards_big__CRvCF","aspect-ratio":"LikeCards_aspect-ratio__xNe3Q"};

/***/ }),

/***/ 6574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgFooter":"BannerAr_imgFooter__oe7aY","mobilecta":"BannerAr_mobilecta__qYJ_o","white":"BannerAr_white__CBdQm","inputEmail":"BannerAr_inputEmail__4GRbN","custom-cta":"BannerAr_custom-cta__gT_Ka"};

/***/ }),

/***/ 3576:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgFooter":"BannerFooter_imgFooter__JWmZf","mobilecta":"BannerFooter_mobilecta__6aw4N","white":"BannerFooter_white__otclw","inputEmail":"BannerFooter_inputEmail__5mbrp","custom-cta":"BannerFooter_custom-cta___JoAl"};

/***/ }),

/***/ 1772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonCta_button__11mLL"};

/***/ }),

/***/ 7129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading-label":"LoadingLabel_loading-label__Mwpie","loadingBackgroundAnimation":"LoadingLabel_loadingBackgroundAnimation__bAvDv"};

/***/ }),

/***/ 4917:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"Masonry_row__L536r","card":"Masonry_card__PxRl1","item":"Masonry_item__gM4MO"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 4051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3366);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);


var _excluded = ["bsPrefix", "className", "noGutters", "as"];



var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
var defaultProps = {
  noGutters: false
};
var Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      noGutters = _ref.noGutters,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  var sizePrefix = decoratedBsPrefix + "-cols";
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var cols;

    if (propValue != null && typeof propValue === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (cols != null) classes.push("" + sizePrefix + infix + "-" + cols);
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    ref: ref
  }, props, {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default().apply(void 0, [className, decoratedBsPrefix, noGutters && 'no-gutters'].concat(classes))
  }));
});
Row.displayName = 'Row';
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [529,774,888,179], function() { return __webpack_exec__(1240); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);